// import React, { Fragment, useState } from "react";
// import { paginate } from "../../utils/paginate";
// import BlogCard from "../Card/BlogCard";
// import BlogCard2 from "../Card/BlogCard2";
// import Card2 from "../Card/Card2";
// import Pagination from "../Common/Pagination";
// import SecTitle from "../Common/SecTitle";
// import { useEffect } from "react";
// import { getNews } from "../../services/NewsService";

// const NewsIndex = () => {
//   const [perPage, setPerPage] = useState(9);
//   const [currentPage, setCurrentPage] = useState(1);

//   const [AllNews, setAllNews] = useState([]);
//   const [recentNews, setRecentNews] = useState([]);
//   const [mostViewdNews, setMostViewsNews] = useState([]);

//   const getNewsList = async () => {
//     try {
//       const data = await getNews();
//       console.log("dataINdex", data);
//       setAllNews(data.data.Data);
//       setRecentNews(data.data.latest_News);
//       setMostViewsNews(data.data.most_popular);
//     } catch (ex) {}
//   };
//   useEffect(() => {
//     getNewsList();
//   }, []);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const paginatedCourses = paginate(AllNews, currentPage, perPage);

//   if (AllNews.length == 0) return null;
//   if (recentNews.length == 0) return null;
//   if (mostViewdNews.length == 0) return null;
//   return (
//     <Fragment>
//       <section className="mt-5">
//         <div className="container">
//           <SecTitle title="پربازدیدترین اخبار" />
//           <div className="row align-items-center mx-0">
//             <div className="col-lg-6">
//               <Card2 data={mostViewdNews[0]} />
//             </div>
//             <div className="col-lg-6 g-3">
//               <div className="row g-4">
//                 <div className="col-lg-6">
//                   <Card2 data={mostViewdNews[1]} />
//                 </div>
//                 <div className="col-lg-6">
//                   <Card2 data={mostViewdNews[2]} />
//                 </div>
//                 <div className="col-lg-6">
//                   <Card2 data={mostViewdNews[3]} />
//                 </div>
//                 <div className="col-lg-6">
//                   <Card2 data={mostViewdNews[4]} />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="blur_bg">
//         <SecTitle title="کل اخبار" />
//         <div className="row mx-0">
//           <div className="col-lg-3">
//             <div className="card ">
//               <div className="card-body rounded-3 shadow-sm">
//                 <h5 className="card-title">جدیدترین اخبار</h5>
//                 {recentNews && recentNews.length !== 0
//                   ? recentNews.map((item) => (
//                       <div key={item.id}>
//                         <hr />
//                         <BlogCard2 data={item} />
//                       </div>
//                     ))
//                   : null}
//               </div>
//             </div>
//           </div>
//           <div className="col-lg-8">
//             <div className="row">
//               {paginatedCourses && paginatedCourses.length !== 0 ? (
//                 paginatedCourses.map((item) => (
//                   <div
//                     key={item.id}
//                     className="col-lg-4 col-md-4 col-md-2 mb-3"
//                   >
//                     <BlogCard item={item} detailsUrl="NewsDetails" />
//                   </div>
//                 ))
//               ) : (
//                 <div className="text-center">داده ای جهت نمایش وجود ندارد</div>
//               )}
//             </div>
//             <Pagination
//               totlal={AllNews.length}
//               currentPage={currentPage}
//               perPage={perPage}
//               onPageChange={handlePageChange}
//             />
//           </div>
//           <div className="col-lg-1"></div>
//         </div>
//       </section>
//     </Fragment>
//   );
// };

// export default NewsIndex;

import React, { Fragment, useEffect, useState } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import BlogCard from "../Card/BlogCard";
import Pagination from "../Common/Pagination";
import SecTitle from "../Common/SecTitle";
import BlogCard2 from "../Card/BlogCard2";
import { getNews } from "../../services/NewsService";
import { paginate } from "../../utils/paginate";
const NewsIndex = () => {
  const [perPage, setPerPage] = useState(9);
  const [currentPage, setCurrentPage] = useState(1);

  const [AllNews, setAllNews] = useState([]);
  const [recentNews, setRecentNews] = useState([]);
  const [mostViewdNews, setMostViewsNews] = useState([]);

  const getNewsList = async () => {
    try {
      const data = await getNews();
      console.log("dataINdex", data);
      setAllNews(data.data.Data);
      setRecentNews(data.data.latest_News);
      setMostViewsNews(data.data.most_popular);
    } catch (ex) {}
  };
  useEffect(() => {
    getNewsList();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedCourses = paginate(AllNews, currentPage, perPage);

  if (AllNews.length == 0) return null;
  if (recentNews.length == 0) return null;
  if (mostViewdNews.length == 0) return null;

  return (
    <Fragment>
      <div className="blur_bg">
        <SecTitle title="جدیدترین اخبار" />
        <Splide
          className="dir_ltr"
          aria-label="My Favorite Images"
          options={{
            rewind: true,
            gap: "1rem",
            perPage: 1,
            type: "loop",
            pagination: false,
            autoplay: true,
            interval: 10000,
            drag: true,
            easing: "ease",
          }}
        >
          <SplideSlide>
            <div className="row align-items-center">
              <div className="col-lg-1"></div>
              <div className="col-lg-4 p-3">
                <img
                  src="/images/company2.jpg"
                  alt="Image 1"
                  className="img-fluid rounded-1"
                />
              </div>
              <div className="col-lg-1"></div>
              <div className="col-lg-5 p-3">
                <div className="content_wrapper text-start">
                  <h2>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                    Voluptatem, dolore.
                  </h2>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Quas vero quia, illo sed praesentium eligendi sapiente
                    beatae reprehenderit modi provident!
                  </p>
                </div>
              </div>
              <div className="col-lg-1"></div>
            </div>
          </SplideSlide>
        </Splide>
      </div>
      <section className="blur_bg">
        <SecTitle title="کل اخبار" />
        <div className="row mx-0">
          <div className="col-lg-12">
            <div className="row">
              {paginatedCourses && paginatedCourses.length !== 0 ? (
                paginatedCourses.map((item) => (
                  <div
                    key={item.id}
                    className="col-lg-3 col-md-4 col-sm-6 col-md-2 mb-3"
                  >
                    <BlogCard item={item} detailsUrl="NewsDetails" />
                  </div>
                ))
              ) : (
                <div className="text-center">داده ای جهت نمایش وجود ندارد</div>
              )}
            </div>
            <Pagination
              totlal={AllNews.length}
              currentPage={currentPage}
              perPage={perPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default NewsIndex;
